import { $fetch, $post, $put } from '@/services/axios';

export function add(data) {
  return $put(`company/lp`, data);
}

export function fetch(data) {
  return $fetch(`company/lps`, data);
}

export function validate(data) {
  return $post(`company/lp/validate`, data);
}

export function edit(data) {
  return $post(`company/lp/${data.id}`, data);
}
